import { Box, Typography, CircularProgress } from "@mui/material";
import { ReactComponent as CoveredTickmarkIcon } from "../../asserts/logo/BlueCircleTick.svg";

const primaryBtnSx = {
  height: 32,
  minHeight: 32,
  px: "16px",
  py: "4px",
  gap: "4px",
  borderRadius: "4px",
  border: "1px solid #BBBBBB",
  backgroundColor: "#F5F5F5",
  backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.04) 100%)",
  color: "#555555",
  boxShadow: "0px 1px 2px 0px #00000014",
  fontFamily: "Lato, sans-serif",
  fontSize: 13,
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: 0,
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  width: "fit-content",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#EEEEEE",
    backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.04) 100%)",
    border: "1px solid #BBBBBB",
    color: "#555555",
  },
};

const ghostBtnSx = {
  height: 32,
  minHeight: 32,
  px: "16px",
  py: "4px",
  gap: "4px",
  borderRadius: "4px",
  border: "1px solid #BBBBBB",
  bgcolor: "#FFFFFF",
  color: "#555555",
  boxShadow: "0px 1px 2px 0px #00000014",
  fontFamily: "Lato, sans-serif",
  fontSize: 13,
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: 0,
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  width: "fit-content",
  cursor: "pointer",
  "&:hover": {
    bgcolor: "#F5F5F5",
    border: "1px solid #BBBBBB",
    color: "#555555",
  },
};

export default function EssentialsCompleteCard({
  overallPct = 0,
  projectName = "This application",
  onViewSummary,
  onStayInChat,
  viewSummaryLoading = false,
}) {
  const displayName = projectName || "This application";
  const pct = Math.round(Number(overallPct) || 0);

  return (
    <Box
      sx={{
        my: 2,
        p: "16px",
        width: "100%",
        maxWidth: "100%",
        minHeight: 114,
        boxSizing: "border-box",
        display: "flex",
        gap: "16px",
        alignItems: "flex-start",
        borderRadius: "8px",
        border: "1px solid #BDD6FF",
        bgcolor: "#F0F6FF80",
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          mt: 0.25,
          lineHeight: 0,
        }}
      >
        <CoveredTickmarkIcon style={{ width: 20, height: 20, display: "block" }} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontSize: 14,
            fontWeight: 900,
            lineHeight: "19px",
            letterSpacing: 0,
            color: "#0046B8",
            mb: 0.75,
          }}
        >
          {`You've covered the essentials — ${pct}% captured`}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "21px",
            letterSpacing: 0,
            color: "#555555",
            mb: 1.5,
          }}
        >
          {`${displayName} has enough detail to move forward. You can review your profile now, or keep asking to fill in the remaining sections.`}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          <Box
            component="button"
            type="button"
            onClick={onStayInChat}
            sx={ghostBtnSx}
          >
            Stay in chat
          </Box>
          <Box
            component="button"
            type="button"
            onClick={onViewSummary}
            disabled={viewSummaryLoading}
            sx={{
              ...primaryBtnSx,
              ...(viewSummaryLoading ? { cursor: "wait", opacity: 0.7 } : {}),
            }}
          >
            {viewSummaryLoading ? <CircularProgress size={14} sx={{ color: "#555555" }} /> : null}
            View summary
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
